<template>
  <div class="editor-secondary-buttons">
    <ElSpace
      :spacer="spacer"
      direction="vertical"
      size="small"
    >
      <ElButtonGroup
        v-for="(buttonArray, index) in ACTION_BUTTONS"
        :key="index"
        class="editor-secondary-buttons__group"
      >
        <ActionButton
          v-for="(btn, i) in buttonArray"
          :key="i"
          modification="panel"
          :disabled="btn.disabled"
          :tooltip="btn.label"
          @click="btn.emit"
        >
          <template #icon>
            <Icon
              :icon="btn.icon"
              size="small"
            />
          </template>
        </ActionButton>
      </ElButtonGroup>
    </ElSpace>
  </div>
</template>

<script setup lang="ts">
import { ElDivider, ElSpace, ElButtonGroup } from 'element-plus'
import { h } from 'vue'
import Icon from '@/components/basic/Icon/Icon.vue'
import ActionButton from '@/components/basic/ActionButton/ActionButton.vue'


interface IActionSecondaryButton {
  label: string
  icon: string
  disabled: boolean
  emit: typeof emit
}

const emit = defineEmits<{
  (e: 'changeLang'): void
  (e: 'addAuthor'): void
  (e: 'showHistory'): void
  (e: 'showRelations'): void
  (e: 'markForbidden'): void
  (e: 'undo'): void
  (e: 'redo'): void
  (e: 'copy'): void
  (e: 'showCodes'): void
  (e: 'showChat'): void
}>()

const spacer = h(ElDivider, { direction: 'horizontal', style: { margin: 0 } })

const TOP_BUTTONS: IActionSecondaryButton[] = [
  {
    label: 'Добавить автора',
    icon: 'user-plus',
    disabled: true,
    emit: () => emit('addAuthor'),
  },
  {
    label: 'Посмотреть историю работы',
    icon: 'history',
    disabled: false,
    emit: () => emit('showHistory'),
  },
  {
    label: 'Посмотреть связанные материалы',
    icon: 'waypoints',
    disabled: false,
    emit: () => emit('showRelations'),
  },
  {
    label: 'Выделить запрещенные организации',
    icon: 'highlighter',
    disabled: true,
    emit: () => emit('markForbidden'),
  },
  {
    label: 'Сменить язык',
    icon: 'languages',
    disabled: true,
    emit: () => emit('changeLang'),
  },
]

const CENTER_BUTTONS: IActionSecondaryButton[] = [
  {
    label: 'Отменить',
    icon: 'undo',
    disabled: true,
    emit: () => emit('undo'),
  },
  {
    label: 'Повторить',
    icon: 'redo',
    disabled: true,
    emit: () => emit('redo'),
  },
  {
    label: 'Скопировать',
    icon: 'copy',
    disabled: true,
    emit: () => emit('copy'),
  },
]

const BOTTOM_BUTTONS: IActionSecondaryButton[] = [
  {
    label: 'Показать коды',
    icon: 'topics',
    disabled: true,
    emit: () => emit('showCodes'),
  },
  {
    label: 'Показать чат',
    icon: 'message-circle',
    disabled: true,
    emit: () => emit('showChat'),
  },
]

const ACTION_BUTTONS: IActionSecondaryButton[][] = [
  TOP_BUTTONS,
  CENTER_BUTTONS,
  BOTTOM_BUTTONS,
]
</script>

<style scoped>
.editor-secondary-buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: min-content;

  padding: var(--ps-padding-s);
  border: 1px solid var(--ps-panel-border-color);
  border-radius: 5px;
}

.editor-secondary-buttons__group {
  display: flex;
  flex-direction: column;
}
</style>
